import { render, staticRenderFns } from "./FormSelectSchool.vue?vue&type=template&id=0099a6fc&scoped=true&"
import script from "./FormSelectSchool.vue?vue&type=script&lang=js&"
export * from "./FormSelectSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0099a6fc",
  null
  
)

export default component.exports